<script setup>
  const props = defineProps({
    filter: Object,
    activeFilters: Object
  })

  const emit = defineEmits(['updateFilter'])

</script>

<template>
  <div class="min-w-lg w-full lg:w-fit">
    <label
      :for="filter.target"
      class="block text-sm/6 text-body">
      {{ filter.title }}
    </label>
    <div class="mt-2 grid grid-cols-1  min-w-lg">
      <select
        :id="filter.target"
        :name="filter.target"
        :value="activeFilters?.[filter.target] ?? 'all'"
        class="col-start-1 row-start-1 w-full appearance-none rounded-md bg-white py-1.5 pl-3 pr-8 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-secondary focus-visible:outline focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-primary sm:text-sm/6"
        @change="emit('updateFilter', $event.target.value, filter.target)"
      >
        <option
          value="all"
          selected
        >
          Alle
        </option>
        <option
          v-for="item in filter.items"
          :key="item.id"
          :value="item.id"
          :disabled="item.disabled"
        >
          {{ item.count !== undefined ? `${item.label} (${item.count})` : item.label }}
        </option>
      </select>
      <svg viewBox="0 0 16 16" fill="currentColor" data-slot="icon" aria-hidden="true" class="pointer-events-none col-start-1 row-start-1 mr-2 size-5 self-center justify-self-end text-gray-500 sm:size-4">
        <path d="M4.22 6.22a.75.75 0 0 1 1.06 0L8 8.94l2.72-2.72a.75.75 0 1 1 1.06 1.06l-3.25 3.25a.75.75 0 0 1-1.06 0L4.22 7.28a.75.75 0 0 1 0-1.06Z" clip-rule="evenodd" fill-rule="evenodd" />
      </svg>
    </div>
  </div>
</template>

<style lang="scss" scoped>

</style>
